module.exports = __webpack_public_path__ + "img/polka2.5392046f.png";